export default __webpack_public_path__ + "static/media/twitter.a7d0974a.svg";